import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { dollars } from "LIB/formatters/currency";
import { countryName } from "LIB/countries";
import { Detail as TableRowDetail } from "MODULES/shared/components/DetailTable";
import { properCase } from "LIB/formatters/text";
import {
  CITY,
  COUNTRY,
  LINE1,
  LINE2,
  POSTAL_CODE,
  REGION,
  STATE
} from "APP_ROOT/constants";
import {
  LIABILITIES_TO_BE_OWED,
  VENDOR_CREDIT_TERMS,
  CUSTOMER_CREDIT_TERMS
} from "MODULES/companies/constants";
import { Link } from "react-router-dom";
import { Liabilities } from "MODULES/companies/components/Detail/Liabilities/Liabilities";

export default function BillingTable({ company }) {
  return (
    <div>
      <table className="table table-condensed">
        <tbody>
          <TableRowDetail
            label="Address Line"
            value={company.getIn(["billing_address", LINE1])}
          />
          <TableRowDetail
            label="Address Line 2"
            value={company.getIn(["billing_address", LINE2])}
            renderIfPresent
          />
          <TableRowDetail
            label={properCase(CITY)}
            value={company.getIn(["billing_address", CITY])}
          />
          <TableRowDetail
            label="State / Province"
            value={company.getIn(["billing_address", STATE])}
          />
          <TableRowDetail
            label="Zip / Postal Code"
            value={company.getIn(["billing_address", POSTAL_CODE])}
          />
          <TableRowDetail
            label={properCase(COUNTRY)}
            value={countryName(company.getIn(["billing_address", COUNTRY]))}
          />
          <TableRowDetail label={REGION} value={company.getIn([REGION])} />
          <TableRowDetail label="EIN #" value={company.get("ein_number")} />
          <TableRowDetail
            label="TAX ID #"
            value={company.get("tax_id_number")}
          />
        </tbody>
      </table>
      <hr className="hr-sm hr-dashed margin-top-none" />
      <table className="table table-condensed">
        <tbody>
          <TableRowDetail
            label="Vendor Terms"
            value={
              company.get(VENDOR_CREDIT_TERMS) &&
              properCase(company.get(VENDOR_CREDIT_TERMS))
            }
          />
          <tr>
            <th className="text-right">Vendor limit</th>
            <td>{dollars(company.get("vendor_credit_limit"))}</td>
          </tr>
        </tbody>
      </table>
      <Liabilities company={company} />
      <table className="table table-condensed">
        <tbody>
          <TableRowDetail
            label="Currently On Order"
            value={
              <Link
                to={`/purchase-orders?cancelled=false&page=1&received=false&filter=${company.get(
                  "name"
                )}`}
              >
                {dollars(company.get(LIABILITIES_TO_BE_OWED))}
              </Link>
            }
          />
          <tr>
            <th className="text-right">Cust Terms</th>
            <td>
              {company.get(CUSTOMER_CREDIT_TERMS) &&
                properCase(company.get(CUSTOMER_CREDIT_TERMS))}
            </td>
          </tr>
          <TableRowDetail
            label="Cust. Limit"
            value={dollars(company.get("customer_credit_limit"))}
          />
          <TableRowDetail
            label="Add'l Liabilities"
            value={
              <Link
                to={`/sales-orders?cancelled=false&cores_received=false&exchange_sale=true&page=1&shipped=true&filter=${company.get(
                  "name"
                )}`}
              >
                {dollars(company.get("additional_liabilities"))}
              </Link>
            }
          />
          <TableRowDetail label="Resale #" value={company.get("resale_num")} />
          <TableRowDetail label="Vat #" value={company.get("vat_num")} />
        </tbody>
      </table>
    </div>
  );
}

BillingTable.propTypes = {
  company: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/BillingTable.jsx